<template>
    <div class="pt-3">
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto form-inline">
                <button class="btn btn-info my-2 my-sm-0"
                        @click="onCreate"
                        type="button">
                    เพิ่มค่ามาตรฐาน
                </button>
            </div>
        </nav>
        <div class="col-12 table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ชื่อแก้ว</th>
                    <th scope="col">ปาก</th>
                    <th scope="col">ยาว(m)</th>
                    <th scope="col">กว้าง(cm.)</th>
                    <th scope="col">หนา(mm.)</th>
                    <th scope="col">จัดการ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(x,i) in list">
                    <td>{{ (i + 1) }}</td>
                    <td>{{ x.name }}</td>
                    <td>{{ x.mouth }}</td>
                    <td>{{ x.m }}</td>
                    <td>{{ x.cm }}</td>
                    <td>{{ x.mm }}</td>
                    <td>
                        <a @click="onEdit(x.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                        &nbsp;&nbsp;
                        <a @click="onDelete(x.id)">
                            <icon name="trash"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <!--        <div v-if="list.length > 0">-->
        <!--            <vue-pagination :pagination="dataPaginate"-->
        <!--                            @paginate="getList">-->
        <!--            </vue-pagination>-->
        <!--        </div>-->
        <b-modal hide-footer hide-header ref="loading">
            <loading :msg="msg" :status="status" @submit="hideLoadingModal"></loading>
        </b-modal>
        <b-modal hide-header hide-footer ref="form_modal" no-close-on-backdrop>
            <div style="text-align: center;">
                <h4>ค่ามาตรฐาน</h4>
                <br/>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ชื่อแก้ว*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ชื่อแก้ว"
                            v-model="form.name"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ปาก*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ปาก"
                            v-model="form.mouth"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">ยาว(m)*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="ยาว(m)"
                            v-model="form.m"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">กว้าง(cm.)*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="กว้าง(cm.)"
                            v-model="form.cm"/>
                    </div>
                </div>
                <div class="row form-group">
                    <div class="col-sm-4 text-right">หนา(mm.)*</div>
                    <div class="col-sm-8">
                        <input
                            class="form-control"
                            placeholder="หนา(mm.)"
                            v-model="form.mm"/>
                    </div>
                </div>
                <br>
                <button @click="onConfirm()"
                        type="button"
                        :disabled="isRequired"
                        class="btn btn-success">
                    ตกลง
                </button>
                &nbsp&nbsp
                <button @click="onCancel"
                        type="button"
                        class="btn btn-outline-secondary">
                    ยกเลิก
                </button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {mapState} from "vuex";
import VuePagination from "../Pagination";
import Multiselect from "vue-multiselect";

import {canViewSuperAdmin} from "../../util/Permissions";

import Loading from "../Utility/Loading";
import DatePicker from "vue2-datepicker";
import Button from "bootstrap-vue/es/components/button/button";

export default {
    name: "product-standard2",
    components: {
        Button,
        Loading,
        VuePagination,
        Multiselect,
        DatePicker
    },
    data() {
        return {
            msg: '',
            status: '',
            list: [],
            form: {
                id: null,
                name: null,
                mouth: null,
                m: null,
                cm: null,
                mm: null,
                type: 'PP'
            },
            dataPaginate: {
                current_page: null,
                from: null,
                last_page: null,
                per_page: null,
                total: null,
                to: null
            }
        };
    },
    created() {
    },
    mounted() {
        this.getList();
    },
    computed: {
        canViewSuperAdmin,
        ...mapState({
            user: state => {
                return state.Auth.user;
            }
        }),
        isRequired() {
            if (this.form.name && this.form.mouth && this.form.m && this.form.cm && this.form.mm)
                return false;
            return true;
        }
    },
    methods: {
        showLoadingModal() {
            this.$refs.loading.show();
        },
        hideLoadingModal() {
            this.$refs.loading.hide();
        },
        getList() {
            this.msg = 'กำลังโหลดข้อมูล กรุณารอสักครู่';
            this.status = 1;
            this.showLoadingModal();
            let data = {
                page: this.dataPaginate.current_page,
                type: 'PP'
            };
            this.$store.dispatch('Standard/getStandardList', data).then(res => {
                this.list = res;
                // this.dataPaginate = {
                //     current_page: res.current_page,
                //     from: res.from,
                //     last_page: res.last_page,
                //     per_page: res.per_page,
                //     total: res.total,
                //     to: res.to
                // }
                this.hideLoadingModal();

            })
        },
        onEdit(id) {
            this.$store.dispatch('Standard/showStandard', id).then(res => {
                this.form = res.data;
                this.$refs.form_modal.show();
            })
        },
        onDelete(id) {
            if (confirm('ต้องการลบรายการนี้หรือไม่'))
                this.$store.dispatch('Standard/deleteStandard', id).then(() => {
                    this.getList();
                })
        },
        onCreate() {
            this.clearModal();
            this.$refs.form_modal.show();
        },
        onConfirm() {
            this.$store.dispatch('Standard/saveStandard', this.form).then(() => {
                this.getList();
                this.onCancel();
                this.clearModal();
            })
        },
        onCancel() {
            this.$refs.form_modal.hide();
        },
        clearModal() {
            this.form = {
                id: null,
                name: null,
                mouth: null,
                m: null,
                cm: null,
                mm: null,
                type: 'PP'
            }
        }
    },
}
</script>

<style lang="scss" scoped>
</style>
